export default IconCornerUpLeftDouble => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-corner-up-left-double" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M19 18v-6a3 3 0 0 0 -3 -3h-7" />
  <path d="M13 13l-4 -4l4 -4m-5 8l-4 -4l4 -4" />
</svg>`;